import classNames from 'classnames'
import PropTypes from 'prop-types'
import AVIcon from './AVIcon'

/**
 *
 * @param title
 * @param type - null, 'reverse', 'cancel'
 * @param icon
 * @param onClick
 * @param muiProps
 * @returns {JSX.Element}
 * @constructor
 */
const Button = ({ title, type = '', icon, onClick, disabled, loading, style }) => {
  let startIcon
  if (icon) {
    switch (icon) {
      case 'record':
        startIcon = <AVIcon iconName="record" color="white" />
        break
      case 'play':
        startIcon = <AVIcon iconName="play" color="white" />
        break
      case 'cancel':
        startIcon = <AVIcon iconName="close" color="white" />
        break
    }
  }
  return (
    <a
      onClick={onClick}
      className={classNames('button', type, { disabled })}
      style={style}
    >
      {icon && !loading && startIcon}
      {title}
    </a>
  )
}

Button.propTypes = {
  type: PropTypes.oneOf(['primary', 'cancel', 'default', 'recording', 'recorded', 'playing']),
}

export default Button
